/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttachmentStorageCorestack extends models.AttachmentStorageBase {
    constructor() {
        super();
        this.setDiscriminator("AttachmentStorageCorestack");
    }

    getFixupPrototypeFunction() { return AttachmentStorageCorestack.fixupPrototype; }

    static newInstance(model: Partial<AttachmentStorageCorestack>): AttachmentStorageCorestack {
        let obj = Object.assign(new AttachmentStorageCorestack(), model);
        AttachmentStorageCorestack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttachmentStorageCorestack>): AttachmentStorageCorestack {
        if (!model) return null;
        return AttachmentStorageCorestack.newInstance(<AttachmentStorageCorestack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttachmentStorageCorestack) {
        if (!obj) return;

        models.AttachmentStorageCorestack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttachmentStorageCorestack): boolean {
        if (models.AttachmentStorageBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AttachmentStorageCorestack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    sys_id: string;

}
